import { useRef } from 'react'
import classNames from 'classnames'
import FilterToggle from '../../../../assets/frontend/js/components/FilterToggle'

type ActionButtonsProps = {
  layoutToggle: React.ReactNode
  collapsed: boolean
  modalId?: string
}

function ActionButtons({
  layoutToggle,
  collapsed,
  modalId
}: ActionButtonsProps) {
  const elementRef = useRef<HTMLDivElement>(null)

  return (
    <div
      ref={elementRef}
      className={classNames('filter-float-panel d-md-none', {
        show: !collapsed
      })}
    >
      <div>
        <div className="filter-float-panel__content" data-bs-theme="dark">
          <div className="filter-panel-button-group justify-content-around">
            {layoutToggle}
            <FilterToggle variant="mobile" modalId={modalId} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActionButtons
